import React from "react";

export default function ShopStallIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 20V30C7 35.6568 7 38.4852 8.75734 40.2426C10.5147 42 13.3431 42 19 42H29C34.6568 42 37.4854 42 39.2426 40.2426C41 38.4852 41 35.6568 41 30V20'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34 15.0029C34 17.7644 31.7614 19.9992 29 19.9992C26.2386 19.9992 24 17.7606 24 14.9992C24 17.7606 21.7614 19.9992 19 19.9992C16.2386 19.9992 14 17.7606 14 14.9992C14 17.7606 11.6531 19.9992 8.75799 19.9992C7.19965 19.9992 5.80013 19.3506 4.83997 18.321C3.18921 16.5509 4.25119 13.9473 5.62893 11.9761L6.40401 10.9163C8.16769 8.50466 9.04953 7.29886 10.3298 6.64914C11.6101 5.99942 13.104 5.99962 16.0917 6.00002L31.9102 6.00212C34.897 6.00252 36.3904 6.00272 37.6702 6.65242C38.95 7.30212 39.8316 8.50754 41.5948 10.9184L42.371 11.9798C43.7488 13.951 44.8108 16.5546 43.16 18.3247C42.1998 19.3543 40.8004 20.0029 39.242 20.0029C36.3468 20.0029 34 17.7644 34 15.0029Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M29.9942 34C28.6266 35.2144 26.4494 36 23.997 36C21.5446 36 19.3675 35.2144 18 34'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
